export default {
  FOLDER: "folder"
};



// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/component/ItemTypes.js